<script>
import PasswordSetupForm from '@/components/auth/PasswordSetupForm.vue';
import AuthService from '@/shared/services/auth.service';

export default {
  name: 'ValidateAccount',
  components: { PasswordSetupForm },
  data() {
    return {
      code: null,
      processing: false,
      errorMessage: null,
      success: false,
    };
  },
  mounted() {
    this.code = this.$route.query.code || null;
  },
  methods: {
    async handleSubmit(password) {
      this.errorMessage = null;

      if (!this.code) {
        this.errorMessage = "Code d'activation invalide ou manquant.";
        return;
      }

      this.processing = true;

      try {
        // Activation and reset share the same endpoint and the same
        // verificationCode column on the backend.
        await AuthService.resetPassword(this.code, password);
        this.success = true;
      } catch (err) {
        this.errorMessage =
          err.response?.data?.message ||
          'Erreur lors de la configuration du mot de passe.';
      } finally {
        this.processing = false;
      }
    },
  },
};
</script>

<template>
  <PasswordSetupForm
    title="Activez votre compte !"
    subtitle="Créez votre mot de passe pour terminer l'activation"
    submit-label="Activer mon compte"
    success-title="Compte activé !"
    success-body="Votre mot de passe est enregistré. Vous pouvez maintenant vous connecter à la plateforme des enquêtes."
    :code="code"
    :processing="processing"
    :api-error="errorMessage"
    :success="success"
    @submit="handleSubmit"
  />
</template>
